<template>
  <article class="cr-row" role="listitem">
    <div class="cr-row__contact">
      <v-icon icon="mdi-phone-outline" size="16" class="cr-row__contact-icon" />
      <span
        class="cr-row__contact-value"
        :title="caller.caller_id_display || caller.caller_id"
      >{{ caller.caller_id_display || caller.caller_id }}</span>
    </div>

    <div class="cr-row__name">
      <span class="cr-row__field-label">Caller name</span>
      <span class="cr-row__name-value" :title="nameLabel">{{ nameLabel }}</span>
    </div>

    <div class="cr-row__last">
      <span class="cr-row__field-label">Last called</span>
      <div class="cr-row__last-text">
        <span class="cr-row__date">{{ dateLabel }}</span>
        <span class="cr-row__clock">{{ timeLabel }}</span>
      </div>
    </div>

    <div class="cr-row__calls">
      <span class="cr-row__field-label">Total calls</span>
      <span class="cr-row__calls-badge">{{ callsLabel }}</span>
    </div>

    <div class="cr-row__actions">
      <CallersActionMenu
        :caller="caller"
        @view="$emit('view', $event)"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
      />
    </div>
  </article>
</template>

<script setup>
import { computed } from 'vue'
import CallersActionMenu from '@/components/Callers/CallersActionMenu.vue'
import { displayCallerName } from '@/composables/callers/useCallersData'
import { formatIsoDate, formatNumber, formatTimeAmPm } from '@/utils/format'

defineOptions({ name: 'CallersRow' })

const props = defineProps({
  caller: { type: Object, required: true },
})

defineEmits(['view', 'edit', 'delete'])

const nameLabel = computed(() => displayCallerName(props.caller.caller_name))
const dateLabel = computed(() => formatIsoDate(props.caller.last_call_on))
const timeLabel = computed(() => formatTimeAmPm(props.caller.last_call_on))
const callsLabel = computed(() => formatNumber(props.caller.total_calls))
</script>
